import { Link } from "react-router-dom";
import { useLang } from "../context/LanguageContext";
import PageHero from "../components/PageHero";
import CtaBand from "../components/CtaBand";
import { Reveal, SectionHeading, Eyebrow } from "../components/Reveal";

const HERO_IMG = "https://images.unsplash.com/photo-1680992046626-418f7e910589?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHxzZXJ2ZXIlMjByb29tJTIwZGFya3xlbnwwfHx8fDE3OTA2MDkxNTZ8MA&ixlib=rb-4.1.0&q=85";

export default function DataCenterAI() {
  const { t } = useLang();
  const dc = t.dc;
  const so = t.home.sovereign;

  return (
    <>
      <PageHero
        testid="dc-hero"
        eyebrow={dc.eyebrow}
        titleLines={dc.title}
        paragraphs={[dc.p1]}
        image={HERO_IMG}
      />

      <section className="py-20 lg:py-28" data-testid="dc-phases">
        <div className="max-w-4xl mx-auto px-6 lg:px-10">
          <SectionHeading eyebrow="EMAN TEAM DYNAMICS" title={dc.phasesTitle} />
          <div className="mt-14 relative">
            <div className="absolute left-[19px] sm:left-1/2 top-0 bottom-0 w-px bg-gradient-to-b from-sovereign/40 via-cobalt/30 to-sovereign/40" aria-hidden="true" />
            <div className="space-y-6">
              {dc.phases.map((ph, i) => (
                <Reveal key={ph} delay={0.05}>
                  <div
                    className={`relative flex items-start gap-5 sm:gap-0 ${i % 2 === 0 ? "sm:flex-row" : "sm:flex-row-reverse"}`}
                    data-testid={`dc-phase-${i}`}
                  >
                    <div className={`hidden sm:block sm:w-1/2 ${i % 2 === 0 ? "sm:pr-12 sm:text-right" : "sm:pl-12"}`}>
                      <div className="glass rounded-lg p-5 inline-block text-left hover:border-sovereign/40 transition-colors duration-400">
                        <span className="font-mono text-[10px] tracking-[0.3em] text-sovereign/60">
                          PHASE {String(i + 1).padStart(2, "0")}
                        </span>
                        <p className="mt-2 font-display text-sm sm:text-base font-bold text-slate-100">{ph}</p>
                      </div>
                    </div>
                    <div className="sm:hidden glass rounded-lg p-5 flex-1">
                      <span className="font-mono text-[10px] tracking-[0.3em] text-sovereign/60">
                        PHASE {String(i + 1).padStart(2, "0")}
                      </span>
                      <p className="mt-2 font-display text-sm font-bold text-slate-100">{ph}</p>
                    </div>
                    <span
                      className="absolute left-[19px] sm:left-1/2 top-6 -translate-x-1/2 w-2.5 h-2.5 bg-sovereign rotate-45 shadow-[0_0_10px_rgba(0,240,255,0.7)]"
                      aria-hidden="true"
                    />
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="relative py-24 border-y border-konect/20 overflow-hidden" data-testid="dc-sovereign">
        <div
          className="absolute inset-0 pointer-events-none"
          style={{ background: "radial-gradient(ellipse 55% 70% at 50% 50%, rgba(255,153,0,0.07), transparent 65%)" }}
          aria-hidden="true"
        />
        <div className="relative max-w-5xl mx-auto px-6 lg:px-10 text-center">
          <Reveal>
            <Eyebrow color="text-konect">{so.eyebrow}</Eyebrow>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="mt-5 font-display text-3xl sm:text-4xl font-extrabold uppercase tracking-tight text-slate-100">
              {so.title}
            </h2>
          </Reveal>
          <Reveal delay={0.14}>
            <p className="mt-6 text-slate-300 max-w-2xl mx-auto">{so.text}</p>
          </Reveal>
          <Reveal delay={0.2}>
            <Link
              to="/konect-systems"
              data-testid="dc-sovereign-cta"
              className="mt-10 inline-flex items-center gap-3 border border-konect/60 text-konect px-8 py-4 font-mono text-xs tracking-[0.25em] uppercase hover:bg-konect/10 transition-all duration-300"
            >
              {so.cta}
              <span aria-hidden="true">→</span>
            </Link>
          </Reveal>
        </div>
      </section>

      <CtaBand title={dc.ctaTitle} text={dc.p1} btn={dc.ctaBtn} />
    </>
  );
}
